module.exports = __webpack_public_path__ + "static/img/AB.4c7fcff1.png";